import { useEffect } from 'react';
import { useAuthActions } from '@frontegg/react';

export default function Logout() {
  const { logout } = useAuthActions();

  useEffect(() => {
    sessionStorage.removeItem('plb_auth_state');
    logout();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Logging out...</div>
    </div>
  );
}
